import authActions from "./Auth";
import usersActions from "./User";
import dealsActions from "./Deal";

export default Object.assign({}, authActions, usersActions, dealsActions);
